define("shared/components/shared/ui/notification-banner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat "cPM--modalBanner--" @status}}>
    <div class="u--row">
      <div class="u--col__9">
        {{! Title }}
        <p class="cPM--modalBanner__title">
          {{@title}}
        </p>
        {{! Text }}
        <p class="cPM--modalBanner__desc">
          {{@description}}
        </p>
      </div>
      <div class="u--col__3">
        {{#if @onClick}}
          {{#if (eq @status "error")}}
            <Shared::Ui::Button
              @onClick={{@onClick}}
              @text={{@buttonText}}
              @variant="outline"
              class={{"cPM--modalBanner__btn--error u--float--right u--m__t__sm u--text--danger"}}
            />
          {{else if (eq @status "warning")}}
            <Shared::Ui::Button
              @onClick={{@onClick}}
              @text={{@buttonText}}
              @variant="outline"
              class={{"cPM--modalBanner__btn--warning u--float--right u--m__t__sm u--text--warning"}}
            />
          {{/if}}
        {{/if}}
      </div>
    </div>
  </div>
  */
  {
    "id": "tVaI38Tc",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"cPM--modalBanner--\",[30,1]],null]],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__title\"],[12],[1,\"\\n        \"],[1,[30,2]],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__desc\"],[12],[1,\"\\n        \"],[1,[30,3]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__3\"],[12],[1,\"\\n\"],[41,[30,4],[[[41,[28,[37,2],[[30,1],\"error\"],null],[[[1,\"          \"],[8,[39,3],[[24,0,\"cPM--modalBanner__btn--error u--float--right u--m__t__sm u--text--danger\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,4],[30,5],\"outline\"]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,2],[[30,1],\"warning\"],null],[[[1,\"          \"],[8,[39,3],[[24,0,\"cPM--modalBanner__btn--warning u--float--right u--m__t__sm u--text--warning\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,4],[30,5],\"outline\"]],null],[1,\"\\n        \"]],[]],null]],[]]]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@status\",\"@title\",\"@description\",\"@onClick\",\"@buttonText\"],false,[\"concat\",\"if\",\"eq\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/ui/notification-banner.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});